import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { Command } from 'cmdk';

import { cn } from 'styles';

type CommandGroupProps = ComponentPropsWithoutRef<typeof Command.Group>;

export const CommandMenuGroup = forwardRef<ElementRef<typeof Command.Group>, CommandGroupProps>(
  ({ className, ...props }, ref) => (
    <Command.Group
      ref={ref}
      className={cn(
        'overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground',
        className,
      )}
      {...props}
    />
  ),
);

CommandMenuGroup.displayName = Command.Group.displayName;
